import { MessageFormatConfig } from 'ngx-translate-messageformat-compiler';

export default {
  biDiSupport: true,
  formatters: {}
} as MessageFormatConfig;